export enum ETYPECLOSED {
    AFTER_CLOSED = 'AFTER_CLOSED',
    BEFORE_CLOSED = 'BEFORE_CLOSED',
}